import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"
import styled from "styled-components"

import { useDenyReferralMutation } from "store/api/referralsApi"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconWarning } from "assets/svg/exclamation-triangle.svg"

import getErrorMessage from "utils/getErrorMessage"
import { ModalLayout } from "layouts/ModalLayout"

const IconWarningContainer = styled.span`
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: var(--status-warning-subtle);
  border-radius: 10px;

  svg path {
    stroke: var(--status-warning);
  }
`

interface Props {
  referralId: number
  onCancel: () => void
  onSuccess: () => void
}

export const DenyReferralModal = ({ referralId, onCancel, onSuccess }: Props) => {
  const [triggerDenyReferral, { isLoading }] = useDenyReferralMutation()

  const onSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()
    if (isLoading) return

    try {
      const res = await triggerDenyReferral(referralId)
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
        return
      }

      toast.success("Referral has been denied!")
      onSuccess()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout
          width="524px"
          confirmButtonColor="redBordered"
          confirmButtonText="Deny"
          onConfirm={onSubmit}
          onCancel={onCancel}
        >
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconWarningContainer>
              <IconWarning />
            </IconWarningContainer>
            <h3 className={styles.modalTitle}>Deny this referral?</h3>
            <div className={styles.modalMessage}>
              This referral will be archived for reporting, not deleted. The customer will not be notified.
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
